export default __webpack_public_path__ + "img/login-image.f67d3dbf.png";